import { Button } from 'antd';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePlayrooms } from '../../context/PlayroomsContext';
import playroomService from '../../services/playroom.service';
import { useBooking } from '../../context/BookingContext';

export default function InitialPage() {
    const navigate = useNavigate();
    const { choosenPlayroom, setChoosenPlayroom } = usePlayrooms();
    const { bookingState, updateBooking} = useBooking();

    useEffect(() => {
        fetchChosenPlayroom();
    }, []);

    const onClick = () => {
        updateBooking("playroomId", choosenPlayroom.id);
        navigate("/playroom-details");
    }

    const fetchChosenPlayroom = () => {
        let playroomId = '69c41ecd-65ca-4696-8105-29202592bb62';
        playroomService.getById(playroomId).then((response) => {
            if (response.status === 200) {
                setChoosenPlayroom(response.data);
            } 
        }).catch((err) => {
            console.log(err);
        })
    }

    return (

        <div className="relative w-full h-screen overflow-hidden">
            <img className="absolute inset-0 w-full h-full object-cover" src="/images/kids_background.png" alt="Children Background" />
            <img className="absolute inset-0 w-full h-full object-cover opacity-100" src="/images/rectangle_background.png" alt="Middle background" />
            <div className="relative z-10 flex flex-col lg:flex-row justify-center items-center h-full px-4 lg:px-16">

                <div className="w-full bg-blend-overlay lg:w-1/2 h-full opacity-90 flex flex-col items-center lg:items-start justify-center m-4 lg:m-0 order-1 lg:order-2 text-white">
                    <h1 className="text-4xl lg:text-7xl font-extrabold mb-4 lg:mb-6">DOBRO DOŠLI</h1>

                    <div className="relative z-10 text-center lg:text-left w-full lg:w-[80%]">
                        <p className="text-xl lg:text-2xl tracking-wide lg:tracking-wider">
                            Želite da rezervišete termin za
                        </p>
                        <p className="text-xl lg:text-2xl tracking-wide lg:tracking-wider">
                            najradosniji dan vašeg mališana?
                        </p>
                        <p className="text-xl lg:text-2xl tracking-wide lg:tracking-wider mb-6">
                            Na pravom ste mjestu!
                        </p>
                        <p className="text-xl lg:text-2xl tracking-wide lg:tracking-wider">
                            Pronađite idealnu rođendaonicu
                        </p>
                        <p className="text-xl lg:text-2xl tracking-wide lg:tracking-wider mb-6">
                            za vas i rezervišite termin.
                        </p>
                    </div>
                    <Button
                        type="submit"
                        className="text-xl lg:text-2xl px-10 py-8 rounded-full bg-white text-footerBlue hover:bg-footerBlue hover:text-white font-bold lg:w-[450px]"
                        onClick={onClick}
                    >
                        REZERVIŠITE SADA
                    </Button>
                </div>

                {/* Div Element 1 - Reversed order on small screens (moved down) */}
                <div className="w-full lg:w-1/2 h-full opacity-90 flex items-center justify-center  lg:m-0 order-2 lg:order-1">
                    <img
                        className="w-full h-full object-cover px-12"
                        src="/images/young_boy.png"
                        alt="Boy on Top"
                    />
                </div>
            </div>
        </div>
    );
}
